import { format } from 'date-fns';
import { Ajax } from '../classes/ajax';
import { requestRepositioning } from '../utils/combinr';
import { DisableStockCheck, EnableStockCheck } from './app';

export function clear(soft) {
    if (soft == null) {
        soft = false;
    }

    return function(dispatch) {
        dispatch({
            type: 'CART/CLEAR',
        });

        const params = {
            security: application.nonce,
            action: 'nch_empty_cart',
        };

        return new Ajax(
            'POST_WORDPRESS',
            NOJESRESOR_WORDPRESS.ajaxurl + '/empty_cart',
            params,
        )
            .then((result) => {
                if (soft) {
                    dispatch({type: 'APP/SOFT_CLEAR'});
                } else {
                    dispatch({type: 'APP/CLEAR'});
                }

                dispatch(clearEmptyCartOverlay());
            })
            .catch((ex) => {
                dispatch({
                    type: 'CART/SEND_TO_WORDPRESS_ERROR',
                });
            });
    };
}

export function Timeout() {
    return function(dispatch) {
        return dispatch({type: 'CART/TIMEOUT'});
    };
}

export function clearEmptyCartOverlay() {
    return function(dispatch) {
        dispatch({
            type: 'CART/CLEAR_EMPTY_CART_OVERLAY',
        });
    };
}

export function ClearCartError() {
    return function(dispatch) {
        return dispatch({
            type: 'CART/SEND_TO_WORDPRESS_ERROR_CLEAR',
        });
    };
}

function validateCartBeforeCheckout(params, cart) {
    if (!cart.optional_hotel && !cart.without_hotel && params.hotel == null) {
        params.tickets = null;
        params.hotel = null;
        params.food = null;
        params.dinner = null;
    }

    return params;
}

export function GoToCheckout() {
    return function(dispatch, getState) {
        dispatch({
            type: 'CART/CREATE',
        });

        dispatch(DisableStockCheck());

        const {cart} = getState();

        const tickets = prepareTickets(cart.confirmed_tickets);
        const hotel = prepareHotel(
            cart.confirmed_hotel,
            cart.confirmed_tickets,
            cart.selected_hotel_range,
            cart.selected_hotel_nights,
            cart.selected_hotel_room_type,
        );
        const food = prepareFood(cart);
        const dinner = prepareDinner(cart);
        let params = {
            security: application.nonce,
            action: 'nch_add_to_cart',
            tickets: tickets,
            hotel: hotel,
            food: food,
            dinner: dinner,
        };

        if (tickets.length > 0) {
            dispatch({
                type: 'CART/START_TIMER',
            });
        }

        params = validateCartBeforeCheckout(params, cart);

        requestRepositioning('start');

        return new Ajax(
            'POST_WORDPRESS',
            NOJESRESOR_WORDPRESS.ajaxurl + '/add_to_cart',
            params,
        )
            .then((result) => {
                if (result.status) {
                    document.location.href = application.links.checkout;
                } else {
                    dispatch({
                        type: 'CART/CREATE_ERROR',
                        payload: {
                            type: result.type,
                            message: result.message,
                        },
                    });

                    dispatch(EnableStockCheck());
                }
            })
            .catch((ex) => {
                dispatch({
                    type: 'CART/CREATE_ERROR',
                    payload: {
                        type: 'unknown',
                        message:
                            'Vi kunde inte skapa din varukorg. Om du vill avsluta din bokning så kan du alltid ringa kundtjänst på 08-500 000 45 eller skicka ett mejl till contact@combinr.io för hjälp.',
                    },
                });

                dispatch(EnableStockCheck());
            });
    };
}

function prepareTickets(confirmedTickets) {
    let tickets = {};

    for (let i = 0, l = confirmedTickets.length; i < l; ++i) {
        let ticket = confirmedTickets[i];

        if (!tickets[ticket.id]) {
            tickets[ticket.id] = {
                id: ticket.id,
                product_id: ticket.product_id,
                quantity: 1,
                custom: {
                    has_food: !!ticket.food_ticket,
                },
            };
        } else {
            tickets[ticket.id].quantity++;
        }
    }

    return Object.values(tickets);
}

function prepareHotel(hotel, tickets, range, nights, roomType) {
    const even = tickets.length % 2 === 0;
    if (even) {
        roomType = null;
    }

    let hotels = [];
    let variations = [];

    for (
        let i = 0,
            l = hotel.ranges[nights][range].variations.length;
        i < l;
        ++i
    ) {
        variations.push(hotel.ranges[nights][range].variations[i].id);
    }

    hotels.push({
        product_id: hotel.id,
        variations: variations,
        custom: {
            people: tickets.length,
            room_types: roomType,
            stay_from: format(hotel.ranges[nights][range].from, 'yyyy-MM-dd'),
            stay_to: format(hotel.ranges[nights][range].to, 'yyyy-MM-dd'),
        },
    });

    return hotels;
}

function prepareFood(state) {
    let confirmed_food = removeFoodProps(state.confirmed_food);
    let confirmed_tickets = state.confirmed_tickets;
    let food = [];
    if (confirmed_tickets.length !== 0 && confirmed_tickets[0].food_ticket) {
        food.push({
            id: confirmed_tickets[0].food_ticket,
            event_id: confirmed_tickets[0].id,
            quantity: confirmed_tickets.length,
            custom: confirmed_food,
        });
    }

    return food;
}

function prepareDinner(state) {
    const confirmed_dinner = state.confirmed_dinner;
    const confirmed_tickets = state.confirmed_tickets;
    let dinner = [];

    if (confirmed_dinner != null && confirmed_dinner.id) {
        dinner.push({
            id: confirmed_dinner.id,
            event_id: confirmed_tickets[0].id,
            quantity: confirmed_tickets.length,
            custom: confirmed_dinner,
        });
    }

    return dinner;
}

function removeFoodProps(confirmed_dinner_or_food) {
    if (!confirmed_dinner_or_food) {
        return confirmed_dinner_or_food;
    }
    return {
        meat: confirmed_dinner_or_food.meat.val,
        fish: confirmed_dinner_or_food.fish.val,
        veg: confirmed_dinner_or_food.veg.val,
    };
}
